import * as actions from './slice'

const userBulkDelete = {
  eventName: 'userBulkDelete',
  onStart: [{
    action: actions.reset,
    redux: true
  }, {
    action: () => actions.setLoading(true),
    redux: true
  }],
  onSuccess: [{
    action: () => actions.setLoading(false),
    redux: true
  }, {
    action: actions.setResults,
    redux: true
  }]
}

export {
  userBulkDelete
}
